import { ScreenContainer, Button, HeroSection, Hero, HeroBody, HeroTitle, HeroTeaser, HeroActionList, HeroAction } from "smooth-doc/components";
import heroBackgroundImageURL from "..\\..\\..\\..\\images\\hero-background.png";
import "..\\..\\..\\..\\src\\styles\\global.css";
import PlFeature from "..\\..\\..\\..\\src\\components\\feature.jsx";
import Calendly from "..\\..\\..\\..\\src\\components\\calendly.jsx";
import alertLevelImg from "..\\..\\..\\..\\images\\pl\\Alert-level.png";
import assessmentImg from "..\\..\\..\\..\\images\\pl\\Assessment.png";
import lessonImg from "..\\..\\..\\..\\images\\pl\\Lesson.png";
import pathwaysImg from "..\\..\\..\\..\\images\\pl\\Pathways.png";
import postAssessmentImg from "..\\..\\..\\..\\images\\pl\\post-assessment.png";
import * as React from 'react';
export default {
  ScreenContainer,
  Button,
  HeroSection,
  Hero,
  HeroBody,
  HeroTitle,
  HeroTeaser,
  HeroActionList,
  HeroAction,
  heroBackgroundImageURL,
  PlFeature,
  Calendly,
  alertLevelImg,
  assessmentImg,
  lessonImg,
  pathwaysImg,
  postAssessmentImg,
  React
};